import { Component, computed, input } from '@angular/core';
import { dsDtos } from '@vectronic/openApi-admin';
import { DetailsItemComponent } from '../../details/details-item/details-item.component';

@Component({
  selector: 'vectronic-belt-info',
  templateUrl: './belt-info.component.html',
  styleUrls: ['./belt-info.component.scss'],
  imports: [DetailsItemComponent],
})
export class BeltInfoComponent {
  belt = input<dsDtos.Belt>();

  length = computed(() => {
    const b = this.belt();
    if (!b) return undefined;
    if (!b.length && b.minimalLength && b.maximalLength) {
      return `${b.minimalLength} - ${b.maximalLength} cm`;
    }
    if (b.minimalLength && b.maximalLength) {
      return `${b.length} cm (${b.minimalLength} - ${b.maximalLength})`;
    }
    if (b.length) {
      return `${b.length} cm`;
    }
    return undefined;
  });
}
